<template>
  <div>
    <div class="jumbotron vh-100 d-flex align-items-center justify-content-center">
      <div class="col-lg-7 col-xl-6 text-lg-left text-center my-5 mr-xl-5">
        <h1 class="display-3 text-white">
          {{ $t('page.home.title') }}
        </h1>
        <p class="lead pb-3 text-white" v-html="$t('page.home.subtitle')"></p>
        <div class="w-100">
          <router-link
            :to="{ name: 'dashboard' }"
            class="landing-btn btn btn-lg btn-primary mt-2"
            id="button-start-now"
          >
            <i class="fa fa-eye"></i>&nbsp; Start nu!
          </router-link>
        </div>
      </div>

      <div class="col-lg-5 text-center pl-lg-5 pl-xl-2 my-5 d-none d-lg-block">
        <div
          class="swiper-container"
          id="landing-recent-commercials"
          v-if="objectList"
        >
          <h4 class="text-white">
            {{ $t('phrase.recent_commercials') }}
          </h4>

          <v-commercial-research-carousel
            :researches="objectList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommercialResearchCarousel from '@/common/components/carousels/CommercialResearchCarousel.vue';
import { mapGetters } from 'vuex';
import { GenericListMixin } from '@/common/utils/mixins';

export default {
  name: 'Home',
  components: {
    'v-commercial-research-carousel': CommercialResearchCarousel,
  },
  data() {
    return {
      apiPath: 'rev/researches/',
    };
  },
  mixins: [
    GenericListMixin,
  ],
  methods: {
  },
  computed: {
    ...mapGetters(['org']),
  },
  created() {
    if (this.org && this.org.name) {
      this.$router.push({ name: 'organisation-dashboard' });
    }
  },
};
</script>


<style scoped>
.jumbotron {
  background: none;
  margin: 0;
}
</style>
